import { createFileRoute } from '@tanstack/react-router';

import { loadSpiMessages, loadSpiPanelScreen, spiPanelScreen, spiPanelSearch } from '@/modules/spi/route';
import { lazyScreen } from '@/shared/screen';

// Gestão SPI no caminho do legado (`router.tsx:669-676`): o menu passa a apontar para cá quando o
// manifesto entra em `src/app/screens.ts`. Arquivo leve (JS inicial); a tela vem em chunk próprio.
export const Route = createFileRoute('/_app/contas-digitais/gestao-spi/')({
  validateSearch: spiPanelSearch,
  staticData: { screen: spiPanelScreen },
  loader: () => loadSpiMessages(),
  component: lazyScreen(loadSpiPanelScreen, 'SpiPanelRouteScreen'),
});
